import React, { useLayoutEffect, useState } from 'react'
import Img from 'gatsby-image'
import Plaatjie from '@ubo/plaatjie'

// Images
import Linkedin from 'img/icon/linkedin_clearmind.inline.svg'
import email from 'img/icon/email.svg'

// Components
import CustomLink from 'components/shared/CustomLink'

// Third Party
import styled, { css } from 'styled-components'
import { motion } from 'framer-motion'
import { useInView } from 'react-hook-inview'
import parse from 'html-react-parser'

const ImgCSS = css`
  position: absolute !important;
  height: 148px;
  width: 148px;
  top: -70px;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  border-radius: 75px;
`

const CustomerPlaatjie = styled(Plaatjie)`
  ${ImgCSS};

  overflow: hidden;
  display: inline-block;
  vertical-align: top;

  & picture img {
    width: 100%;
    object-fit: cover;
    height: 100%;
    left: 0;
    top: 0;
    position: absolute;
  }
`

const CustomerImg = styled(Img)`
  ${ImgCSS};
`

const StyledCustomer = styled(motion.div)`
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
  border-radius: 20px;
  padding: 100px 5px 20px 5px;
  position: relative;
  height: 280px;
  margin-bottom: 8em;

  h2 {
    position: relative;
    &::before {
      content: '';
      position: absolute;
      background: ${(props) => props.theme.color.gradient.main};
      width: 120%;
      height: 3px;
      left: -10%;
      border-radius: 1.5px;
      bottom: -20px;
    }
  }

  p {
    font-size: ${(props) => props.theme.font.size.s};
    margin-bottom: 0;
    line-height: 20px;
  }
`

const StyledCustomLink = styled(CustomLink)``

const Buttons = styled.div`
  position: absolute;
  bottom: 30px;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
`

const Customer = ({ className, content }) => {
  const [ref, isVisible] = useInView({
    threshold: 0.3,
  })

  const [view, setView] = useState(false)

  useLayoutEffect(() => {
    if (isVisible && !view) {
      setView(true)
    }
  }, [isVisible])

  return (
    <StyledCustomer
      className={`${className ? `${className}` : ``}`}
      ref={ref}
      initial={{ opacity: 0.3, y: 80 }}
      animate={
        isVisible
          ? { opacity: 1, y: 0, transition: { type: 'spring', duration: 0.5 } }
          : {}
      }
    >
      {content.acf.preview.image?.localFile?.childImageSharp?.fluid ? (
        <CustomerImg
          loading="eager"
          fadeIn={false}
          fluid={content.acf.preview.image.localFile.childImageSharp.fluid}
          alt=""
        />
      ) : (
        <CustomerPlaatjie
          loading="eager"
          fadeIn={false}
          image={content.acf.preview.image}
          alt=""
        />
      )}
      <div className="d-flex justify-content-center pb-4">
        <h2 className="float-left font-weight-xl font-size-ms text-center">
          {content.title}
        </h2>
      </div>
      <div className="text-center">
        {parse(content.acf.preview.description)}
      </div>
      <Buttons className="d-flex justify-content-center pt-5 align-items-center">
        <motion.div
          whileHover={{
            rotate: [0, -20, 20, 0],
            transition: { duration: 0.3 },
          }}
          className="mr-3"
        >
          <StyledCustomLink to={content.acf.preview.linkedin}>
            <Linkedin />
          </StyledCustomLink>
        </motion.div>
        <motion.div
          whileHover={{
            rotate: [0, -20, 20, 0],
            transition: { duration: 0.3 },
          }}
        >
          <StyledCustomLink external to={`mailto:${content.acf.preview.email}`}>
            {/* <Email /> */}
            <img src={email} alt="" />
          </StyledCustomLink>
        </motion.div>
      </Buttons>
    </StyledCustomer>
  )
}

export default Customer
